<template>
  <component :is="MarketCard" :marketId="marketID" :eventId="eventID" />
</template>

<script lang="ts">
import { defineComponent, defineAsyncComponent, computed } from "vue";
import { Market } from "@fresh8/types/lib/betData";
import {
  LISTS,
  MAIN_MARKETS,
  FULL_TIME_RESULT,
  PROMOS
} from "../constants/market-types";
import { injectBetData } from "@fresh8/ad-data-composition/src/betData";

/**
 * Checks if event can display main market markets
 */
const isMultiFtr = (eventMarkets: Market[]) => {
  const ftrMarkets = eventMarkets.filter(market =>
    MAIN_MARKETS.includes(market.marketType)
  );
  return ftrMarkets.length > 1;
};

/**
 * Checks if market display a draw option
 */
const isFtr = (eventMarket: Market) => {
  return eventMarket.options.length > 2;
};

/**
 * Gets the appropriate ftr card for the events ftr markets
 */
const getFtrCard = eventMarkets =>
  isMultiFtr(eventMarkets)
    ? defineAsyncComponent(() => import(`./ftr/Wrapper.vue`))
    : isFtr(eventMarkets[0])
    ? defineAsyncComponent(() => import(`./win-draw-win/Wrapper.vue`))
    : defineAsyncComponent(() => import(`./win-win/Wrapper.vue`));

const MARKET_CARD_MAP = {
  default: defineAsyncComponent(() => import(`./list/Wrapper.vue`))
};

MARKET_CARD_MAP[FULL_TIME_RESULT] = getFtrCard;

MAIN_MARKETS.forEach(market => {
  MARKET_CARD_MAP[market] = getFtrCard;
});

LISTS.forEach(market => {
  MARKET_CARD_MAP[market] = defineAsyncComponent(() =>
    import(`./list/Wrapper.vue`)
  );
});

PROMOS.forEach(market => {
  MARKET_CARD_MAP[market] = defineAsyncComponent(() =>
    import(`./promo/Wrapper.vue`)
  );
});

export default defineComponent({
  name: "CardSelector",
  props: {
    marketIds: Array
  },
  setup(props) {
    const betData = injectBetData();

    const markets = computed(() => {
      return props.marketIds.map((id: string) => betData.markets.value[id]);
    });

    const MarketCard = computed(() => {
      const marketCardSetter =
        MARKET_CARD_MAP[markets.value[0].marketType] || MARKET_CARD_MAP.default;

      if (typeof marketCardSetter === "function") {
        return marketCardSetter(markets.value);
      } else {
        return marketCardSetter;
      }
    });

    return {
      MarketCard,
      marketID: computed(() => markets.value[0].marketId),
      eventID: computed(() => markets.value[0].eventId)
    };
  }
});
</script>
